import { ErrorResponse } from "../../../utils";
import { State } from "./state";
import { COMMANDS } from "../../../shared";
import { Action as TAction, StoreDispatchProps } from "../../../Store";
import { Dispatch } from "redux";
import { actionCreator } from "../../../ajax";
import { Omit } from "../../../utils";

export namespace Actions {
  // ACTION TYPES
  export const REQUEST_GET = "io/request/linq8acm/inputs/get";
  export const REQUEST_POST = "io/request/linq8acm/inputs/post";
  export const RESPONSE_GET = "io/response/linq8acm/inputs/get";
  export const RESPONSE_POST = "io/response/linq8acm/inputs/post";
  export const RESPONSE_POST_END = "io/response/linq8acm/inputs/post/end";
  export const EDIT = "io/edit/linq8acm/inputs";
  export const EDIT_COMMANDS = "io/edit/commands/linq8acm/inputs";
  export const POLL_START = "io/poll/linq8acm/inputs/start";
  export const POLL_STOP = "io/poll/linq8acm/inputs/stop";

  // ACTION INTERFACES
  type Requests = GetRequest | PostRequest;
  export interface GetRequest extends TAction<typeof REQUEST_GET> {}
  export interface PostRequest extends TAction<typeof REQUEST_POST> {
    data: Partial<State.Data>;
    post?: State.ServerRequest;
  }
  export interface GetResponse extends TAction<typeof RESPONSE_GET> {
    data: State.ServerResponse;
  }
  export interface PostResponse extends TAction<typeof RESPONSE_POST> {
    data: ErrorResponse;
  }
  export interface PostResponseEnd extends TAction<typeof RESPONSE_POST_END> {}
  export interface Edit extends TAction<typeof EDIT> {
    data: Omit<Partial<State.Input>, "cmds">;
    idx: number;
  }
  export interface EditCommands extends TAction<typeof EDIT_COMMANDS> {
    idx: number;
    output: number;
    url: string;
    cmd: COMMANDS;
  }
  export interface PollStart extends TAction<typeof POLL_START> {}
  export interface PollStop extends TAction<typeof POLL_STOP> {}

  export interface DispatchProps extends StoreDispatchProps<State.Data> {}

  // ACTIONS
  export const getRequest = actionCreator<GetRequest>(REQUEST_GET);
  export const getResponse = actionCreator<GetResponse>(RESPONSE_GET);
  export const postRequest = actionCreator<PostRequest>(REQUEST_POST);
  export const postResponse = actionCreator<PostResponse>(RESPONSE_POST);
  export const postResponseEnd = actionCreator<PostResponseEnd>(
    RESPONSE_POST_END
  );
  export const pollStart = actionCreator<PollStart>(POLL_START);
  export const pollStop = actionCreator<PollStop>(POLL_STOP);
  export const edit = actionCreator<Edit>(EDIT);
  export const editCommands = actionCreator<EditCommands>(EDIT_COMMANDS);
  export function fetchRequest(): GetRequest;
  export function fetchRequest(data: Partial<State.Data>): PostRequest;
  export function fetchRequest(data?: Partial<State.Data>): Requests {
    return data ? postRequest({ data }) : getRequest();
  }

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      edit: (idx: number, data: Partial<State.Input>) =>
        dispatch(edit({ data, idx })),
      editCommands: (idx: number, url: string, output: number, cmd: COMMANDS) =>
        dispatch(editCommands({ idx, output, url, cmd })),
      fetch: (data?: Partial<State.Data>) =>
        dispatch(data ? fetchRequest(data) : fetchRequest()),
      poll: (p: boolean) =>
        dispatch(p ? pollStart({ data: p }) : pollStop({ data: p }))
    };
  };
}
